import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import notificationService from "../../../../api/Notification/NotificationService";
import NotificationService from "../../../../api/Notification/NotificationService";
export default class UpdateNotification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allAvailableNotifications: [],
      selectedNotification: {
        id: null,
        title: null,
        dept: null,
        description: null,
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllNotifications();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };
  getAllNotifications = () => {
    this.setState({ allAvailableNotifications: [] });
    notificationService
      .getAllNotifications()
      .then((res) => {
        res.data.map((notification, i) => {
          console.log("category:", notification);
          return this.setState({
            allAvailableNotifications: [
              ...this.state.allAvailableNotifications,
              {
                key: i + 1,
                id: notification.id,
                title: notification.title,
                dept: notification.dept,
                description: notification.description,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  selectNotifications = () => {
    return this.state.allAvailableNotifications?.map((notification) => {
      return <option value={notification.id}>{notification.title}</option>;
    });
  };

  onSelectNotification = (e) => {
    this.state.allAvailableNotifications.map(
      (notification) =>
        e.target.value === notification.id &&
        this.setState({
          selectedNotification: {
            id: notification.id,
            title: notification.title,
            dept: notification.dept,
            description: notification.description,
          },
        })
    );
  };

  updateNotification = () => {
    console.log("selected category", this.state.selectedNotification);
    NotificationService.editNotification(this.state.selectedNotification.id, {
      title: this.state.selectedNotification.title,
      dept: this.state.selectedNotification.dept,
      description: this.state.selectedNotification.description,
    });
    document.getElementById("title").value = "";
    document.getElementById("dept").value = "";
    document.getElementById("description").value = "";
    toast.success(`Notification Updated Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getAllNotifications();
  };

  onChangeNotificationData = (e) => {
    let selectedNotification = this.state.selectedNotification;
    selectedNotification[e.target.name] = e.target.value;
    this.setState({ selectedNotification });
  };

  render() {
    let selectNotifications = this.selectNotifications();
    return (
      <>
        <Row>
          <Col>
            <h5 className="m-0">Update Notification</h5>
          </Col>
          <Col>
            <div class="form-group" id="role">
              <select
                class="form-control"
                id="role"
                onChange={this.onSelectNotification}
              >
                <option value="#">Select Notification</option>
                {selectNotifications}
              </select>
            </div>
          </Col>
        </Row>
        <Row form>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Title</label>
              <FormControl
                autoFocus
                type="text"
                id="title"
                name="title"
                defaultValue={this.state.selectedNotification.title}
                onChange={this.onChangeNotificationData}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Department</label>
              <FormControl
                autoFocus
                type="text"
                id="dept"
                name="dept"
                defaultValue={this.state.selectedNotification.dept}
                onChange={this.onChangeNotificationData}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group">
            <FormGroup controlId="email">
              <label>Description</label>
              <FormControl
                autoFocus
                type="text"
                id="description"
                name="description"
                defaultValue={this.state.selectedNotification.description}
                onChange={this.onChangeNotificationData}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.updateNotification}
            >
              Resend
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
